import React from 'react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { steps } from '../data/content';
export function PathwaySection() {
  return <section className="w-full bg-ink py-16 sm:py-24" aria-label="The 6-step diagnostic pathway" data-id="element-226" data-mp="23on22dm7q7oe">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-227" data-mp="28n6qckoa3vjx">
        <SectionHeading title={<>
              The Parasitic Drain <span className="text-volt" data-id="element-229" data-mp="1byik0llxdwqc">Diagnostic Pathway™</span>
            </>} sub="A 6-step system for organizing complex battery drain investigations. Instead of approaching every unexplained discharge differently, follow a repeatable professional workflow." data-id="element-228" data-mp="28mojyv7wk0ya" />

        <ol className="relative mx-auto mt-12 grid max-w-3xl gap-0 lg:max-w-none lg:grid-cols-3 lg:gap-6" data-id="element-230" data-mp="1py05os3xctvh">
          {steps.map((s, i) => {
          const Icon = s.icon;
          return <li key={s.name} className="relative flex gap-4 pb-8 lg:flex-col lg:rounded-2xl lg:bg-navy lg:p-6" data-id="element-231" data-mp="31b2g15ffkn77" data-mpi={i}>
                {i < steps.length - 1 && <span className="absolute left-[27px] top-14 h-[calc(100%-56px)] w-0.5 bg-line lg:hidden" aria-hidden="true" data-id="element-232" data-mp="2s3p8gyu129h1" />}
                <div className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-volt text-ink" data-id="element-233" data-mp="2i5rmkhzn4orl">
                  <Icon className="h-7 w-7" strokeWidth={2.5} aria-hidden="true" data-id="element-234" data-mp="2d7gcc65foc8u" />
                </div>
                <div data-id="element-235" data-mp="28ewomgd180qb">
                  <p className="font-display text-base font-bold uppercase tracking-wider text-spark" data-id="element-236" data-mp="28eexfy588cp9">
                    Step {String(i + 1).padStart(2, '0')}
                  </p>
                  <h3 className="font-display text-3xl font-extrabold uppercase leading-none text-white" data-id="element-237" data-mp="1zgbd355z9lz1">
                    {s.name}
                  </h3>
                  <p className="mt-2 text-base font-semibold text-white" data-id="element-238" data-mp="1ph3zcgvbzpbe">{s.lead}</p>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-mist" data-id="element-239" data-mp="1ft821bax1gpv">{s.body}</p>
                </div>
              </li>;
        })}
        </ol>

        <p className="mt-6 text-center font-display text-2xl font-bold uppercase text-white sm:text-3xl" data-id="element-240" data-mp="1ktmct13wj4rl">
          One pathway. Six stages. <span className="text-volt" data-id="element-241" data-mp="1au59urg1b4zb">A more organized diagnostic process.</span>
        </p>

        <SectionCta label="I want the 6-step system" data-id="element-242" data-mp="1avydryz9jb3m" />
      </div>
    </section>;
}